import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import Button from 'components/CncUI/Button';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(({ breakpoints }) => ({
  edit: {
    padding: '0px 8px',
    '& .MuiSvgIcon-root': {
      fontSize: 22,
      marginRight: 4,
    },
  },
}));

const EditAction = ({ action }) => {
  const classes = useStyles();
  if (!action) return null;
  return (
    <Button
      tertiary
      short
      white
      className={classes.edit}
      onClick={action}
    >
      <EditIcon />{' '}
      <Typography component="span" variant="body2" size="short" noMargin white>
        edit
      </Typography>
    </Button>
  );
};

export default EditAction;
